import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  contactForm: {
    id: 'views.Contact.Form.contactForm',
    defaultMessage: 'Formularz Kontaktowy'
  },
  name: {
    id: 'views.Contact.Form.name',
    defaultMessage: 'Imię i nazwisko'
  },
  company: {
    id: 'views.Contact.Form.company',
    defaultMessage: 'Firma'
  },
  email: {
    id: 'views.Contact.Form.email',
    defaultMessage: 'Adres e-mail'
  },
  dataProcessingAgreement: {
    id: 'views.Contact.Form.dataProcessingAgreement',
    defaultMessage:
      'Wyrażam zgodę na przetwarzanie moich danych osobowych podanych powyżej przez TenderHut Spółka Akcyjna (ul. Sienkiewicza 110, 15-005 Białystok, e-mail: <a href="mailto:{mail}">{mail}</a>) w następujących celach: odpowiedzi na przesłane zapytanie i komunikację marketingową poprzez elektroniczne i tradycyjne środki komunikacji.'
  },
  submitButton: {
    id: 'views.Contact.Form.submitButton',
    defaultMessage: 'SPOTKAJMY SIĘ'
  },
  buttonMessageSuccess: {
    id: 'views.Contact.Form.buttonMessageSuccess',
    defaultMessage: 'Dziekujemy!'
  },
  buttonMessageError: {
    id: 'views.Contact.Form.buttonMessageError',
    defaultMessage: 'Uppss... Coś poszło nie tak ;('
  },
  buttonMessageLoading: {
    id: 'views.Contact.Form.buttonMessageLoading',
    defaultMessage: 'Wysyłanie'
  },
  messageNoCheckbox: {
    id: 'views.Contact.Form.messageNoCheckbox',
    defaultMessage: 'Wszystkie zgody są wymagane!'
  },
  messageNoCheckboxes: {
    id: 'views.Contact.Form.messageNoCheckboxes',
    defaultMessage: 'Te pola są wymagane!'
  }
});



// WEBPACK FOOTER //
// ./src/views/Contact/Components/Form/Form.intl.js